import { render, staticRenderFns } from "./MultiImg.vue?vue&type=template&id=c081a43a&scoped=true&"
import script from "./MultiImg.vue?vue&type=script&lang=js&"
export * from "./MultiImg.vue?vue&type=script&lang=js&"
import style0 from "./MultiImg.vue?vue&type=style&index=0&id=c081a43a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c081a43a",
  null
  
)

export default component.exports